import { CallTranscriptResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useGetCallTranscript(
  twilioSsid: string,
  alarmGroupId?: string,
  locationAlarmId?: string,
  enabled = false
) {
  const queryParams = new URLSearchParams();
  if (alarmGroupId) {
    queryParams.append('alarm_group_id', alarmGroupId);
  } else if (locationAlarmId) {
    queryParams.append('location_alarm_id', locationAlarmId);
  }

  const url = `/v2/orm/voice/twilio/call_transcript/${twilioSsid}?${queryParams.toString()}`;
  const request = new Request(url);

  return useAuthenticatedRequest<CallTranscriptResponse>(request, {
    queryKey: ['call_transcript', twilioSsid, alarmGroupId, locationAlarmId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    enabled: enabled && !!(alarmGroupId || locationAlarmId),
  });
}

export default useGetCallTranscript;
